import Box from '@mui/material/Box';
import eLinkLogoWhite from '../assets/elink_distribution_ag_logo_white.svg';
import eLinkLogo from '../assets/elink_distribution_ag_logo.svg';
import { SxProps } from '@mui/material';

export function Logo({
  variant = 'light',
  sx,
}: {
  variant: 'light' | 'dark';
  sx?: SxProps;
}) {
  return (
    <Box
      sx={{
        height: '24px',
        my: 4,
        ...sx,
      }}
    >
      <img
        style={{
          height: '100%',
          width: 'auto',
        }}
        src={variant === 'light' ? eLinkLogoWhite : eLinkLogo}
        alt={'eLink Distribution AG'}
      />
    </Box>
  );
}
